import script from "./AccountManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountManagement.vue?vue&type=script&setup=true&lang=js"

import "./AccountManagement.vue?vue&type=style&index=0&id=0289f658&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0289f658"]])

export default __exports__